<script setup>
defineProps({
  category: {
    type: String,
    required: true,
  },
});

const iconMap = {
  'Local SEO': {
    icon: 'local-seo',
    class: 'tw-text-actions-localSeo',
  },
  'Content': {
    icon: 'content',
    class: 'tw-text-actions-content',
  },
  'Keywords': {
    icon: 'keywords',
    class: 'tw-text-actions-keyword',
  },
  'Link Building': {
    icon: 'link-building',
    class: 'tw-text-actions-linkBuilding',
  },
  'Onsite': {
    icon: 'onsite',
    class: 'tw-text-actions-onsite',
  },
  'Pagespeed': {
    icon: 'pagespeed',
    class: 'tw-text-actions-pagespeed',
  },
  'Technical': {
    icon: 'technical',
    class: 'tw-text-actions-technical',
  },
  'Competitors': {
    icon: 'competitors',
    class: 'tw-text-actions-competitors',
  },
  'Connections': {
    icon: 'connections',
    class: 'tw-text-actions-connections',
  },
  'Manual': {
    icon: 'technical',
    class: 'tw-text-actions-technical',
  },
}

</script>

<template>
  <div class="tw-flex tw-items-center tw-justify-center tw-h-10 tw-w-10 tw-rounded-lg tw-bg-grey-highlight">
    <svg-vue
      :icon="`icons/actions-${iconMap[category].icon}`"
      :class="['tw-p-2', iconMap[category].class]"
    />
  </div>
</template>
